export default __webpack_public_path__ + "static/media/22_photo.170e0e11.jpg";